var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBcpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.1875C5.58281 15.1875 2.8125 12.4172 2.8125 9C2.8125 5.58281 5.58281 2.8125 9 2.8125C12.4172 2.8125 15.1875 5.58281 15.1875 9C15.1875 12.4172 12.4172 15.1875 9 15.1875ZM9 14.5676C12.0746 14.5676 14.5676 12.0746 14.5676 9C14.5676 5.92537 12.0746 3.43238 9 3.43238C5.92537 3.43238 3.43238 5.92537 3.43238 9C3.43238 12.0746 5.92537 14.5676 9 14.5676ZM12.3992 6.8175C12.492 8.47012 10.9648 8.90662 10.9648 8.90662C12.7102 9.15581 12.6169 10.6526 12.6169 10.6526C12.6169 13.0837 9.9045 13.1788 9.9045 13.1788H6.10031V4.82175H9.53044C12.3992 4.94662 12.3992 6.8175 12.3992 6.8175ZM8.06456 6.31856V8.34469H9.43706C9.43706 8.34469 10.4034 8.31375 10.4653 7.53412V7.03519C10.4653 7.03519 10.4653 6.381 9.52987 6.31856H8.06456ZM10.6521 10.9029V10.4034C10.6521 10.4034 10.6521 9.74813 9.71719 9.68569H8.064V11.7135H9.62381C9.62381 11.7135 10.5902 11.6826 10.6526 10.9024L10.6521 10.9029Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcpt);
export default __webpack_public_path__ + "static/media/bcpt.894c272f2f1e8da077cd0b48fb6d3588.svg";
export { ForwardRef as ReactComponent };